import previewIcon from '../assets/img/preview-icon-btn.svg';
import { useAtom } from 'jotai';
import { selectedSearchResultAtom } from '../store/insuranceSearchStore.js';
import { openHikiukeDetail, HIKIUKE_TAB_LIMIT } from '../utils/insuranceSearchUtil.js';

const HikiukeResultCard = ({ result, isDragging, companyId, selectedResults, setSelectedResults }) => {
  const [, setSelectedSearchResult] = useAtom(selectedSearchResultAtom);

  const handleCardClick = (result) => {
    const isSelected = selectedResults.some((selected) => selected.id === result.id);
    if (isSelected) {
      setSelectedResults(prev => prev.filter(selected => !(selected.id === result.id)));
    } else {
      if (selectedResults.length >= HIKIUKE_TAB_LIMIT) {
        alert(`一括確認できる傷病は${HIKIUKE_TAB_LIMIT}件までです。`);
        return;
      }
      setSelectedResults(prev => [...prev, result]);
    }
  };

  const openDetail = (e) => {
    e.stopPropagation();

    // ドラッグ状態の安全なチェック
    const isDraggingActive = isDragging?.current && companyId && isDragging.current[companyId];

    // PC表示時かつドラッグ中でない場合は通常のナビゲーション
    if (!isDraggingActive) {
      openHikiukeDetail([result], setSelectedSearchResult);
    }
  }

  return (
    <div className={`result-card result-card--container ${result.lowAcceptance === true ? 'result-card-underwriting' : ''}`}>
      {result.lowAcceptance === true && (
        <div className='result-card-label'>
          <span className='result-card-label-left'>！</span>
          <span className='result-card-label-right'>引受の可能性低</span>
        </div>
      )}
      <div className="disease-checkbox">
        <label className="checkbox-native-box--underwriting">
          <input
            type="checkbox"
            className="checkbox-native--underwriting"
            checked={selectedResults.some((selected) => selected.id === result.id)}
            onChange={() => handleCardClick(result)}
          />
        </label>
        <span
          className='disease-checkbox-text'
          onClick={() => handleCardClick(result)}
        >
          {result.diseaseName}
        </span>
      </div>
      <button onClick={openDetail} className='disease-view-btn'>
        <span className='disease-view-btn-text'>開く</span>
        <img
          src={previewIcon}
          alt=""
          className='disease-view-btn-icon'
          width="12"
          height="12"
        />
      </button>
    </div>
  );
};

export default HikiukeResultCard;